export const SENTRY_DSN =
  "https://df83883bc9967c70641aff6361c9c9e5@o4508715123015680.ingest.us.sentry.io/4508715124588544";
export const SENTRY_AUTH_TOKEN =
  "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";
export const SENTRY_ORG = "unifylist";
export const SENTRY_PROJECT = "unifylist-frontend";
